import { eduIDApi } from "./common";
export const authnApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        authenticate: builder.query({
            query: (body) => ({
                url: "authenticate",
                body,
            }),
            extraOptions: { service: "authn" },
        }),
        authnGetStatus: builder.query({
            query: (body) => ({
                url: "get-status",
                body,
            }),
            extraOptions: { service: "authn" },
        }),
    }),
});
export default authnApi;
